export const NoData = ({
    titleBlue,
    titleBlack,
    description,
    buttonText,
    onButtonClick,
    icon = 'plusicon_w',
}: {
    titleBlue?: string;
    titleBlack?: string;
    description?: string;
    button?: boolean;
    buttonText?: string;
    onButtonClick?: () => void;
    icon?: string;
}) => {
    return (
        <div className="view_wrap">
            <div className="viewBox">
                <div className="report-content ttukttak_report-content">
                    <div className="layout-type1">
                        <div className="class-datas-wrap block">
                            <div className="class-datas">
                                <div className="search-no-result ttukttak_search-no-result">
                                    {titleBlue && (
                                        <p className="desc-01 cont-mt3">
                                            <span className="point">{titleBlue}</span>
                                        </p>
                                    )}
                                    {titleBlack && <p className="desc-02 cont-mt3">{titleBlack}</p>}
                                    {description && <p className="desc-03">{description}</p>}
                                    {buttonText && (
                                        <button
                                            className={`btn btn-default blue icon ${icon} submittedBtn`}
                                            onClick={onButtonClick && onButtonClick}
                                        >
                                            <i></i>
                                            {buttonText}
                                        </button>
                                    )}
                                </div>
                            </div>
                            {/* //class-datas */}
                        </div>
                        {/* //class-datas-wrap */}
                    </div>
                </div>
            </div>
        </div>
    );
};
